import { c as _c } from "react/compiler-runtime";
import { H1 } from '@/frontend/design-system/_marketing/typography/Heading';
import { P1 } from '@/frontend/design-system/_marketing/typography/Paragraph';
import { Button } from '@/frontend/design-system/actions/Button';
import { TextDecorator } from '@/frontend/design-system/atoms/TextDecorator';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
import { FAQ } from './_svg/FAQ';
export function TopSection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VerticalSpacer size="top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto flex max-w-screen-sm flex-col items-center text-balance text-center"><H1>Najczęściej zadawane pytania <TextDecorator variant="gradient">(FAQ)</TextDecorator></H1><VerticalSpacer size="content" /><P1>Aby ułatwić Ci dostęp do potrzebnych informacji, stworzyliśmy listę najczęściej zadawanych pytań wraz z odpowiedziami. Jeśli masz inne pytania, skontaktuj się z nami – chętnie pomożemy!</P1><VerticalSpacer size="button" /><Button size="xl" href="/kontakt" className="w-full lg:w-fit">Skontaktuj się z nami</Button><VerticalSpacer size="content" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <main className="">{t0}{t1}<div className="mx-auto flex max-w-screen-sm flex-col"><FAQ /></div></main>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}